module.exports = __webpack_public_path__ + "assets/img/device-message-configuration.6dcb57bb.svg";